var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-tray-wrapper-edit ugc-tray-wrapper-edit--flex"
  }, [_vm.tmallEnabled && _vm.isMy ? _c('input', {
    ref: _vm.inputId,
    staticClass: "hide ugc-image-source",
    attrs: {
      "id": _vm.inputId,
      "type": "button",
      "accept": "image/jpg,image/jpeg,image/png",
      "name": _vm.inputId
    },
    on: {
      "click": _vm.setUGCImageTmall
    }
  }) : _c('input', {
    ref: _vm.inputId,
    staticClass: "hide ugc-image-source",
    attrs: {
      "id": _vm.inputId,
      "type": "file",
      "accept": "image/jpg,image/jpeg,image/png",
      "name": _vm.inputId
    },
    on: {
      "change": _vm.setUGCImage
    }
  }), _c('button', {
    staticClass: "button ugc-tray-wrapper-button ugc-tray-wrapper-edit-apply-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onUploadClick
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n      " + _vm._s(_vm.textLabel || _vm.translations[_vm.inputLabel]) + "\n    ")])]), _c('button', {
    staticClass: "ugc-tray-wrapper-edit-container-button",
    attrs: {
      "disabled": _vm.disableButton,
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_c('span', {
    staticClass: "icon icon-camera"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.buttonText))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }